export const GET_RATES = 'GET_BOOKING_RATES'
export const SET_RATES = 'SET_BOOKING_RATES'

export const SELECT_RATE = 'SELECT_RATE'
export const CLEAR_SELECTED_RATE = 'CLEAR_SELECTED_RATE'
export const SET_SELECTED_RATE_DETAILS = 'SET_SELECTED_RATE_DETAILS'
export const SET_SELECTED_VEHICLE = 'SET_SELECTED_VEHICLE'
export const REMOVE_FROM_SELECTED_VEHICLES = 'REMOVE_FROM_SELECTED_VEHICLES'
export const SET_SELECTED_CREDIT_CARD = 'SET_SELECTED_CREDIT_CARD'

export const SET_LAST_BOOKING_DETAILS = 'SET_LAST_BOOKING_DETAILS'
export const CLEAR_LAST_BOOKING_DETAILS = 'CLEAR_LAST_BOOKING_DETAILS'

export const GET_BOOKING_LOCATION_DETAILS = 'GET_BOOKING_LOCATION_DETAILS'
export const SET_BOOKING_LOCATION_DETAILS = 'SET_BOOKING_LOCATION_DETAILS'

export const ACCEPT_TERMS_AND_CONDITIONS = 'ACCEPT_TERMS_AND_CONDITIONS'

export const LAST_BOOKING_REDEEM_PROMO_CODE = 'LAST_BOOKING_REDEEM_PROMO_CODE'
export const LAST_BOOKING_REDEEMED_PROMO_CODE = 'LAST_BOOKING_REDEEMED_PROMO_CODE'
export const LAST_BOOKING_REMOVE_PROMO_CODE = 'LAST_BOOKING_REMOVE_PROMO_CODE'
export const LAST_BOOKING_SET_AUTO_RENEW = 'LAST_BOOKING_SET_AUTO_RENEW'
export const SET_RAW_PROMO_CODE = 'SET_RAW_PROMO_CODE'

export const ENABLE_CARD = 'ENABLE_CARD'
export const DISABLE_ALL_CARDS = 'DISABLE_ALL_CARDS'

export const EXIT_BOOKING_FLOW = 'EXIT_BOOKING_FLOW'

export const SELECT_SEASON_TICKET = 'SELECT_SEASON_TICKET'
export const RECEIVED_SELECTED_SEASON_TICKET_RATE = 'RECEIVED_SELECTED_SEASON_TICKET_RATE'
export const SET_PARKING_MODE = 'SET_PARKING_MODE'

export const RECEIVED_WAITING_LIST_RATE = 'RECEIVED_WAITING_LIST_RATE'

// These values are compared to the ones coming from API
export const SHOW_HOURLY_FLOW = ['PNW', 'RAD']
export const SHOW_MONTHLY_FLOW = ['MNY']
export const SHOW_EVENTS_FLOW = ['EVT']
export const SHOW_PREPAID_FLOW = ['PPC']

export const RESERVATION_IN_PROGRESS = 'INPROGRESS'
